module.exports = __webpack_public_path__ + "img/banner.492528c5.png";